import { render, staticRenderFns } from "./CiLanguageChooser.vue?vue&type=template&id=312c9c47&scoped=true&"
import script from "./CiLanguageChooser.vue?vue&type=script&lang=js&"
export * from "./CiLanguageChooser.vue?vue&type=script&lang=js&"
import style0 from "./CiLanguageChooser.vue?vue&type=style&index=0&id=312c9c47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312c9c47",
  null
  
)

component.options.__file = "CiLanguageChooser.vue"
export default component.exports